<span class="file-type">{{ fileTypeOrExtension() }}</span>
